import { EventDispatcher } from './EventDispatcher';
import GlobalStore from '../datastorage/GlobalStore';
import gsap from 'gsap';
import barba from '@barba/core';

export default class ContentButtonController {
    constructor() {
        this._isBtnFooterRegistered = false;

        EventDispatcher.on('pageTransition', this.handlePageTransition.bind(this));
    }

    handlePageTransition(e) {
        if (e.detail.namespace === 'after' || e.detail.namespace === 'once') {
            this.checkContentButtons();
        }
    }

    contentNavigation(btn) {
        btn.addEventListener('click', this.contentNavigationClick.bind(this));

        if (GlobalStore.get('device') === 'desktop') {
            btn.addEventListener('mouseover', this.contentNavigationOver.bind(this));
            btn.addEventListener('mouseout', this.contentNavigationOut.bind(this));
        }
    }

    contentNavigationClick(e) {
        e.preventDefault();

        const url = e.currentTarget.dataset.btnUrl;
        const target = e.currentTarget.dataset.btnTarget;
        const type = e.currentTarget.dataset.btnType;

        if (type === 'page') {
            barba.go(url);
        } else if (type === 'url') {
            if (target === '_blank') {
                window.open(url, '_blank');
            } else {
                barba.force(url);
            }
        }
    }

    contentNavigationOver(e) {
        const btnLabel = e.currentTarget.querySelector('.btn-label');

        if (!e.currentTarget.dataset.colBg && !btnLabel.dataset.colTxt) {
            const colBg = gsap.getProperty(e.currentTarget, 'backgroundColor');
            e.currentTarget.dataset.colBg = colBg;

            const colTxt = gsap.getProperty(btnLabel, 'color');
            e.currentTarget.colTxt = colTxt;
        }

        gsap.to(e.currentTarget, {
            backgroundColor: (i, el) => gsap.getProperty(el, '--col-bg-contentbtn-active'),
            duration: 0.65,
            ease: 'power2.out',
        });

        gsap.to(btnLabel, {
            color: (i, el) => gsap.getProperty(el, '--col-font-main-white'),
            duration: 0.65,
            ease: 'power2.out',
        });
    }

    contentNavigationOut(e) {
        gsap.to(e.currentTarget, {
            backgroundColor: e.currentTarget.dataset.colBg,
            duration: 0.65,
            ease: 'power2.out',
        });

        gsap.to(e.currentTarget.querySelector('.btn-label'), {
            color: e.currentTarget.colTxt,
            duration: 0.65,
            ease: 'power2.out',
        });
    }

    checkContentButtons() {
        document.querySelectorAll('[data-btn-name]').forEach((el) => {
            const fn = el.dataset.btnName;
            const parentId = el.parentNode.id;
            const isFooter = parentId === 'wrapper-footer-navigation';
            const method = this[fn];

            if (typeof method !== 'function') return;

            if (isFooter) {
                if (this._isBtnFooterRegistered) return;
                this._isBtnFooterRegistered = true;
            }

            method.call(this, el);
        });
    }
}
